import axios from "axios";
import { toast } from "react-toastify";
import {
  GET_RESOURCE_TASKS_REQUEST,
  GET_RESOURCE_TASKS_SUCCESS,
  GET_RESOURCE_TASKS_ERROR,
  GET_RESOURCE_TASKS_CHUNK,
  SET_RESOURCE_TASKS_SCOPE,
  LOOK_AHEAD_RT_LOAD_FAILED,
  MLAP_LOAD_FAILED,
  GET_RESOURCE_TASKS_FROM_CACHE,
  CREATE_RESOURCE_TASK_REQUEST,
  CREATE_RESOURCE_TASK_SUCCESS,
  CREATE_RESOURCE_TASK_ERROR,
  UPDATE_RESOURCE_TASK_REQUEST,
  UPDATE_RESOURCE_TASK_SUCCESS,
  UPDATE_RESOURCE_TASK_ERROR,
  DELETE_RESOURCE_TASK_REQUEST,
  DELETE_RESOURCE_TASK_SUCCESS,
  DELETE_RESOURCE_TASK_ERROR,
  ASSIGN_RESOURCE_TASK_REQUEST,
  ASSIGN_RESOURCE_TASK_SUCCESS,
  CHECK_IS_MANAGER_SUCCESS,
  CHECK_IS_MANAGER_ERROR,
  GET_RESOURCE_TASKS_BY_SCENARIO_ID_REQUEST,
  GET_RESOURCE_TASKS_BY_SCENARIO_ID_SUCCESS,
  GET_RESOURCE_TASKS_BY_SCENARIO_ID_ERROR,
  TOP_DOWN_RESOURCE_TASK_UPDATE,
  GET_RESOURCE_TASKS_DASHBOARD_REQUEST,
  GET_RESOURCE_TASKS_DASHBOARD_SUCCESS,
  GET_RESOURCE_TASKS_DASHBOARD_ERROR,
  GET_RESOURCE_TASKS_CUSTOM_COLUMNS_REQUEST,
  GET_RESOURCE_TASKS_CUSTOM_COLUMNS_SUCCESS,
  GET_RESOURCE_TASKS_CUSTOM_COLUMNS_ERROR,
  GET_RESOURCE_TASKS_CUSTOM_COLUMN_NAMES_SUCCESS,
  GET_RESOURCE_TASKS_CUSTOM_COLUMN_NAMES_REQUEST,
  GET_RESOURCE_TASKS_CUSTOM_COLUMN_NAMES_ERROR,
  ADD_RT_CUSTOM_COLUMNS,
  UPDATE_USER_TASK,
  UPDATE_USER_TASK_STATUS_AND_PROGRESS,
  SET_BACKLOG_STATUSES,
  UPDATE_BATCH_OF_REGULARS,
  DELETE_BATCH_OF_RESOURCE_TASKS,
} from "../types";
import { PDA_PREFIX, PERSONAL, USER_TASKBOARD_DATE_FILTER } from "../../global/constants";
import { logout } from "../security-services/SecurityActions";
import {
  windowInsideCoverage,
  windowsOverlap,
  missingBands,
  mergeCoverage,
} from "../../utils/periodWindow/periodWindow";
import logoutforSpecificErrorCodes from "../../securityUtils/LogoutUtils";
import {
  updateRegular,
  MAX_LOADED_ROWS,
  warnRowLimitReached,
} from "../schedule-activity-services/scheduleActivityActions";
import { setRegularToAnimate } from "../../components/Bryntum/Scheduler/utils";
import { getDateRange } from "../../utils/DateUtils/DateUtils";
import { runWithConcurrency } from "../../utils/asyncUtils/runWithConcurrency";
import { t } from "i18next";

// actions

const getResourceTasksRequest = () => ({
  type: GET_RESOURCE_TASKS_REQUEST,
});

const getResourceTasksSuccess = (tasks) => ({
  type: GET_RESOURCE_TASKS_SUCCESS,
  payload: tasks,
});

const getResourceTasksError = (error) => ({
  type: GET_RESOURCE_TASKS_ERROR,
  payload: error,
});

const createResourceTaskRequest = () => ({
  type: CREATE_RESOURCE_TASK_REQUEST,
});

const createResourceTaskSuccess = (task) => ({
  type: CREATE_RESOURCE_TASK_SUCCESS,
  payload: task,
});

const createResourceTaskError = (error) => ({
  type: CREATE_RESOURCE_TASK_ERROR,
  payload: error,
});

const assignResourceTaskRequest = () => ({
  type: ASSIGN_RESOURCE_TASK_REQUEST,
});

const assignResourceTaskSuccess = (task) => ({
  type: ASSIGN_RESOURCE_TASK_SUCCESS,
  payload: task,
});

const assignResourceTaskError = (error) => ({
  type: CREATE_RESOURCE_TASK_ERROR,
  payload: error,
});

const updateResourceTaskRequest = () => ({
  type: UPDATE_RESOURCE_TASK_REQUEST,
});

const updateResourceTaskSuccess = (task) => ({
  type: UPDATE_RESOURCE_TASK_SUCCESS,
  payload: task,
});

const updateResourceTaskError = (error) => ({
  type: UPDATE_RESOURCE_TASK_ERROR,
  payload: error,
});

const deleteResourceTaskRequest = () => ({
  type: DELETE_RESOURCE_TASK_REQUEST,
});

const deleteResourceTaskSuccess = (id) => ({
  type: DELETE_RESOURCE_TASK_SUCCESS,
  payload: id,
});

const deleteResourceTaskError = (error) => ({
  type: DELETE_RESOURCE_TASK_ERROR,
  payload: error,
});

const checkIsManagerSuccess = (isManager) => ({
  type: CHECK_IS_MANAGER_SUCCESS,
  payload: isManager,
});

const checkIsManagerError = (error) => ({
  type: CHECK_IS_MANAGER_ERROR,
  payload: error,
});

const getResourceTasksByScenarioIdRequest = () => ({
  type: GET_RESOURCE_TASKS_BY_SCENARIO_ID_REQUEST,
});

const getResourceTasksByScenarioIdSuccess = (tasks) => ({
  type: GET_RESOURCE_TASKS_BY_SCENARIO_ID_SUCCESS,
  payload: tasks,
});

const getResourceTasksByScenarioIdError = (error) => ({
  type: GET_RESOURCE_TASKS_BY_SCENARIO_ID_ERROR,
  payload: error,
});

const getResourceTasksDashboardRequest = () => ({
  type: GET_RESOURCE_TASKS_DASHBOARD_REQUEST,
});

const getResourceTasksDashboardSuccess = (tasks) => ({
  type: GET_RESOURCE_TASKS_DASHBOARD_SUCCESS,
  payload: tasks,
});

const getResourceTasksDashboardError = (error) => ({
  type: GET_RESOURCE_TASKS_DASHBOARD_ERROR,
  payload: error,
});

export const topDownResourceTaskUpdate = (tasks) => ({
  type: TOP_DOWN_RESOURCE_TASK_UPDATE,
  payload: tasks,
});

const getResourceTaskCustomColumnsRequest = () => ({
  type: GET_RESOURCE_TASKS_CUSTOM_COLUMNS_REQUEST,
});

const getResourceTaskCustomColumnsSuccess = (columns) => ({
  type: GET_RESOURCE_TASKS_CUSTOM_COLUMNS_SUCCESS,
  payload: columns,
});

const getResourceTaskCustomColumnsError = (error) => ({
  type: GET_RESOURCE_TASKS_CUSTOM_COLUMNS_ERROR,
  payload: error,
});

const getResourceTaskCustomColumnNamesRequest = () => ({
  type: GET_RESOURCE_TASKS_CUSTOM_COLUMN_NAMES_REQUEST,
});

const getResourceTaskCustomColumnNamesSuccess = (columns) => ({
  type: GET_RESOURCE_TASKS_CUSTOM_COLUMN_NAMES_SUCCESS,
  payload: columns,
});

const getResourceTaskCustomColumnNamesError = (error) => ({
  type: GET_RESOURCE_TASKS_CUSTOM_COLUMN_NAMES_ERROR,
  payload: error,
});

const addRtCustomColumns = (data) => ({
  type: ADD_RT_CUSTOM_COLUMNS,
  payload: data,
});

///  Fetch

export const checkIsManager = () => async (dispatch) => {
  try {
    const managerRes = await axios.get(
      `${PDA_PREFIX}/resource-tasks/is-manager/`
    );
    const isManager = managerRes.status == 200;
    dispatch(checkIsManagerSuccess(isManager));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(checkIsManagerError(err.message));
  }
};

// Resource tasks are heavier per row than schedule activities (each carries segments), so a
// smaller chunk and a tighter concurrency cap keep per-request backend memory bounded — wide
// periods otherwise OOM the pods / 504 the page.
const RT_CHUNK_SIZE = 500;
const RT_CHUNK_CONCURRENCY = 3;
const RT_LOOK_AHEAD_URL = `${PDA_PREFIX}/resource-tasks/extended-resource-tasks`;

// Latest request key, so chunks from a superseded period (the user changed period mid-stream)
// are dropped instead of appending stale rows.
let activeResourceTasksKey = null;
// Filters-only part of the cache key: coverage/pool are only reusable while the non-date
// filters (projects/resources) are identical — same contract as the SA look-ahead. With
// server-side filtering, mixing pools from different filter sets would show wrong rows.
export const resourceTasksFilterKey = (dateFilter = {}) => {
  const projects = [...(dateFilter.projectNames || [])].sort().join(",");
  const resources = [...(dateFilter.resourceIds || [])].sort().join(",");
  return `${projects}|${resources}`;
};
const resourceTasksKey = (dateFilter = {}) =>
  `${dateFilter.start}|${dateFilter.finish}|${resourceTasksFilterKey(dateFilter)}`;
const fetchResourceTasksChunk = (dateFilter, chunk, chunkSize) =>
  axios.post(`${RT_LOOK_AHEAD_URL}?chunk=${chunk}&chunkSize=${chunkSize}`, dateFilter);

/**
 * Loads the look-ahead Gantt resource tasks progressively: first chunk renders immediately,
 * the rest stream in through a small concurrency pool and append (deduped by resourceTask.id).
 * Falls back to the legacy single-array response if the backend isn't paginating.
 */
export const getResourceTasks = (dateFilter, { force = false } = {}) => async (
  dispatch,
  getState
) => {
  const key = resourceTasksKey(dateFilter);
  const win = { start: dateFilter.start, finish: dateFilter.finish };
  activeResourceTasksKey = key;

  try {
    // Delta-band period cache: narrowing re-windows the pool locally (zero network),
    // widening fetches only the missing band(s). The RT endpoint's interval predicate is an
    // INCLUSIVE OVERLAP (MLAP-FILTER DEC-1: a spanning task is in), so band fetches need no
    // backend flag.
    // Coverage is only reusable while the project/resource filters are identical: the
    // pool now holds SERVER-FILTERED rows, so a filter change must fall through to the
    // full reload below (fresh pool for the new filter set).
    const filterKey = resourceTasksFilterKey(dateFilter);
    const coverage = getState()?.scheduler?.tasksCoverage;
    const coverageReusable =
      coverage && (coverage.filterKey ?? "|") === filterKey;
    if (!force && coverageReusable) {
      if (windowInsideCoverage(win, coverage)) {
        // Narrowing completes synchronously — no loading marker (a complete:false marker
        // here stranded the streaming flag/chip forever, nothing ever completed it).
        dispatch({ type: SET_RESOURCE_TASKS_SCOPE, payload: { window: win, coverage } });
        return;
      }
      if (windowsOverlap(win, coverage)) {
        // Scope first (settles streaming flags), then the loading marker for the band stream.
        const newCoverage = { ...mergeCoverage(win, coverage), filterKey };
        dispatch({ type: SET_RESOURCE_TASKS_SCOPE, payload: { window: win, coverage: newCoverage } });
        dispatch({ type: GET_RESOURCE_TASKS_CHUNK, payload: { rows: [], replace: false, complete: false } });
        for (const bandWindow of missingBands(win, coverage)) {
          await streamResourceTaskChunks(dispatch, { ...dateFilter, ...bandWindow }, key, { replaceFirst: false, band: true });
          if (activeResourceTasksKey !== key) return;
        }
        return;
      }
    }

    // Full reload (first load, disjoint window, filters changed, forced refresh,
    // post-mutation). Scope first (settles streaming flags), then the loading marker.
    dispatch({ type: SET_RESOURCE_TASKS_SCOPE, payload: { window: win, coverage: { ...win, filterKey }, resetPool: true } });
    dispatch({ type: GET_RESOURCE_TASKS_CHUNK, payload: { rows: [], replace: false, complete: false } });
    await streamResourceTaskChunks(dispatch, dateFilter, key, { replaceFirst: true });
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getResourceTasksError(err.message));
    // MLAP-FILTER DEC-5: a refused/failed request is never rendered as an empty result.
    if (activeResourceTasksKey === key) dispatch(lookAheadRtLoadFailed(err));
  }
};

const lookAheadRtLoadFailed = (err) => ({
  type: LOOK_AHEAD_RT_LOAD_FAILED,
  payload: { code: MLAP_LOAD_FAILED, status: err?.response?.status ?? null },
});

// Streams one chunked RT load (a full window or a delta band) into the pool.
const streamResourceTaskChunks = async (
  dispatch,
  dateFilter,
  key,
  { replaceFirst = false, band = false } = {}
) => {
  const firstRes = await fetchResourceTasksChunk(dateFilter, 1, RT_CHUNK_SIZE);
  if (activeResourceTasksKey !== key) return;

  if (firstRes.status === 204 || !firstRes.data) {
    dispatch({ type: GET_RESOURCE_TASKS_CHUNK, payload: { rows: [], replace: replaceFirst, complete: true, key } });
    return;
  }

  const meta = firstRes.data.meta;
  if (meta && typeof meta.totalChunks === "number") {
    const chunkSize = meta.chunkSize || RT_CHUNK_SIZE;
    // Row-limit guard: stop issuing chunks at the cap and warn, instead of loading a
    // volume the page cannot survive (see MAX_LOADED_ROWS).
    const maxChunks = Math.max(1, Math.floor(MAX_LOADED_ROWS / chunkSize));
    const totalChunks = Math.min(meta.totalChunks, maxChunks);
    const capped = meta.totalChunks > totalChunks;
    if (capped) warnRowLimitReached(meta.totalRows);

    dispatch({
      type: GET_RESOURCE_TASKS_CHUNK,
      // totalRows feeds the non-blocking "X / Y rows" streaming chip; band loads add to the
      // already-pooled rows (the reducer offsets by the pool size at dispatch time).
      // When capped, the chip target is what will actually be loaded.
      payload: { rows: firstRes.data.data || [], replace: replaceFirst, complete: totalChunks <= 1, key, totalRows: capped ? totalChunks * chunkSize : meta.totalRows, band, incompleteDates: meta.incompleteDates },
    });

    if (totalChunks > 1) {
      const remainingChunkNumbers = [];
      for (let chunk = 2; chunk <= totalChunks; chunk++) {
        remainingChunkNumbers.push(chunk);
      }
      let remaining = remainingChunkNumbers.length;
      const taskFactories = remainingChunkNumbers.map((chunkIndex) => async () => {
        if (activeResourceTasksKey !== key) {
          remaining -= 1;
          return;
        }
        try {
          const res = await fetchResourceTasksChunk(dateFilter, chunkIndex, chunkSize);
          remaining -= 1;
          if (activeResourceTasksKey !== key) return;
          dispatch({
            type: GET_RESOURCE_TASKS_CHUNK,
            payload: { rows: (res.data && res.data.data) || [], replace: false, complete: remaining === 0, key },
          });
        } catch (e) {
          remaining -= 1;
          if (activeResourceTasksKey === key) {
            // A lost chunk is a partial payload (L7): settle the stream, but flag the load as
            // failed so the pane shows a refusal instead of a silently incomplete list (DEC-5).
            dispatch(lookAheadRtLoadFailed(e));
            if (remaining === 0) {
              dispatch({ type: GET_RESOURCE_TASKS_CHUNK, payload: { rows: [], replace: false, complete: true, key } });
            }
          }
        }
      });
      await runWithConcurrency(taskFactories, RT_CHUNK_CONCURRENCY);
    }
  } else {
    // Legacy: backend returned the full array (no pagination).
    const rows = Array.isArray(firstRes.data) ? firstRes.data : firstRes.data.data || [];
    dispatch({ type: GET_RESOURCE_TASKS_CHUNK, payload: { rows, replace: replaceFirst, complete: true, key } });
  }
};

export const getUserResourceTasks = (dateFilter, type) => async (dispatch) => {
  dispatch(getResourceTasksRequest());
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/resource-tasks/user-tasks`,
      dateFilter,
      { params: { type } }
    );
    if (Array.isArray(res.data)) {
      res.data.forEach(task => {
        if (task.projectName === PERSONAL) {
          task.projectName = t("global.personal");
        }
      });
    }
    dispatch(getResourceTasksSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getResourceTasksError(err.message));
    // toast.error("Something went wrong");
  }
};

export const getResourceTasksByScenarioId = (scenarioId) => async (
  dispatch
) => {
  dispatch(getResourceTasksByScenarioIdRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/resource-tasks/scenario/${scenarioId}`
    );
    const tasks = res.data.map((task) => ({ resourceTask: task }));
    dispatch(getResourceTasksByScenarioIdSuccess(tasks));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getResourceTasksByScenarioIdError(err.message));
    // toast.error("Something went wrong");
  }
};

export const doActionAndRefetch = (
  apiRoute,
  requestMethod,
  datesFilter,
  args = undefined,
  scenarioId,
  animateParent = false
) => async (dispatch) => {
  try {
    const route = `${PDA_PREFIX}/resource-tasks/${apiRoute}`;
    // await Reflect.apply(null, axios[requestMethod], [route, ...args]);
    const method = axios[requestMethod];

    const response = await (args ? method(route, args) : method(route));
    let res;
    if (scenarioId) {
      res = await axios.get(
        `${PDA_PREFIX}/resource-tasks/scenario/${scenarioId}`
      );
      const tasks = res.data.map((task) => ({ resourceTask: task }));
      dispatch(getResourceTasksByScenarioIdSuccess(tasks));
    } else {
      return Promise.all([
        dispatch(getResourceTasks(datesFilter)),
        dispatch(getResourceTaskCustomColumns()),
        dispatch(getResourceTaskCustomColumnNames()),
      ]);
    }

    if (response.data.parent?.scheduleActivity) {
      if (animateParent) {
        setRegularToAnimate(response.data.parent.scheduleActivity.id);
      }
      dispatch(updateRegular(response.data.parent));
    }

    return Promise.resolve(res.data);
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getResourceTasksError(err.message));
    toast.error(t("global.errors.someChangesWereNotSaved"));
  }
};

export const getResourceTaskById = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${PDA_PREFIX}/resource-tasks/${id}`);
    return res;
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error(t("global.errors.somethingWentWrong"));
    return;
  }
};

/**
 * Creates a new resource task with custom fields support.
 * Fetches custom columns after creation to ensure real-time display.
 * 
 * @param {Object} data - Task creation data including customFields map
 * @returns {Function} Redux thunk action
 */
export const createResourceTask = (data) => async (dispatch) => {
  // dispatch(createResourceTaskRequest()); // PLEASE DO NOT ACTIVATE
  try {
    const res = await axios.post(`${PDA_PREFIX}/resource-tasks/create`, data);
    
    // Fetch and transform custom columns for real-time display
    const resourceTask = res.data.resourceTask;
    if (resourceTask && resourceTask.id) {
      try {
        const customColumnsRes = await axios.get(
          `${PDA_PREFIX}/resource-tasks/custom-column/${resourceTask.id}`
        );
        const customColumns = customColumnsRes.data.reduce((columns, column) => {
          resourceTask[`customColumn-${column.name}`] = column.value;
          columns[column.name] = column.value;
          return columns;
        }, {});
        resourceTask.customColumns = customColumns;
      } catch (customColumnsErr) {
        // Custom columns fetch failed, but task creation succeeded
      }
    }
    
    dispatch(createResourceTaskSuccess(res.data));
    
    toast.success(
      <div>
        <b>{data.name}</b> {t('taskFocus.toastMsg.hasBeenCreatedFor')} <b>{data.resourceName}</b>
      </div>
    );
    return Promise.resolve(res.data);
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(createResourceTaskError(err.message));
    toast.error("Something went wrong");
  }
};

export const createResourceTaskForCurrentUser = (data) => async (dispatch) => {
  // dispatch(createResourceTaskRequest()); // PLEASE DO NOT ACTIVATE
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/resource-tasks/create/current-user/${data.status}`,
      data
    );
    dispatch(createResourceTaskSuccess(res.data));
    return Promise.resolve(res.data);
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(createResourceTaskError(err.message));
    toast.error(t("global.errors.somethingWentWrong"));
  }
};

export const assignResourceTask = (data) => async (dispatch) => {
  //dispatch(assignResourceTaskRequest()); // PLEASE DO NOT ACTIVATE
  try {
    const res = await axios.post(`${PDA_PREFIX}/resource-tasks/assign`, data);
    const resourceTask = res.data.child.resourceTask;
    const customColumnsRes = await axios.get(
      `${PDA_PREFIX}/resource-tasks/custom-column/${resourceTask.id}`
    );
    const customColumns = customColumnsRes.data.reduce((columns, column) => {
      resourceTask[`customColumn-${column.name}`] = column.value;
      columns[column.name] = column.value;
      return columns;
    }, {});
    const customColumnToAdd = { ...customColumns, id: resourceTask.id };
    resourceTask.customColumns = customColumns;
    dispatch(addRtCustomColumns([customColumnToAdd]));
    dispatch(updateRegular(res.data.parent));
    dispatch(assignResourceTaskSuccess(res.data));
    toast.success(
      <div>
        {t('taskFocus.toastMsg.taskAssignedTo')} <b>{resourceTask.resource.name}</b>
      </div>
    );
    return true;
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(assignResourceTaskError(err.message));
    toast.error(t("global.errors.somethingWentWrong"));
    return false;
  }
};

export const smartAssignResourceTask = (data) => async (dispatch) => {
  try {
    const res = await axios.post(`${PDA_PREFIX}/resource-tasks/smart-assign`, data);
    const resourceTask = res.data.child.resourceTask;
    const customColumnsRes = await axios.get(
      `${PDA_PREFIX}/resource-tasks/custom-column/${resourceTask.id}`
    );
    const customColumns = customColumnsRes.data.reduce((columns, column) => {
      resourceTask[`customColumn-${column.name}`] = column.value;
      columns[column.name] = column.value;
      return columns;
    }, {});
    const customColumnToAdd = { ...customColumns, id: resourceTask.id };
    resourceTask.customColumns = customColumns;
    dispatch(addRtCustomColumns([customColumnToAdd]));
    dispatch(updateRegular(res.data.parent));
    dispatch(assignResourceTaskSuccess(res.data));
    return { success: true };
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    if (err.response?.status === 409) {
      return { success: false, skipped: true };
    }
    dispatch(assignResourceTaskError(err.message));
    return { success: false, skipped: false };
  }
};

export const getResourceTasksDashboard = (dateFilter, type) => async (
  dispatch
) => {
  dispatch(getResourceTasksDashboardRequest());
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/resource-tasks/dashboard`,
      dateFilter,
      { params: { type } }
    );
    dispatch(getResourceTasksDashboardSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getResourceTasksDashboardError(err.message));
  }
};

export const assignResourceTaskFromGantt = (data) => async (dispatch) => {
  //dispatch(assignResourceTaskRequest()); // PLEASE DO NOT ACTIVATE
  try {
    const res = await axios.post(`${PDA_PREFIX}/resource-tasks/assign`, data);
    const resourceTask = res.data.child.resourceTask;
    const customColumnsRes = await axios.get(
      `${PDA_PREFIX}/resource-tasks/custom-column/${resourceTask.id}`
    );
    const customColumns = customColumnsRes.data.reduce((columns, column) => {
      columns[column.name] = column.value;
      return columns;
    }, {});
    const customColumnToAdd = { ...customColumns, id: resourceTask.id };
    resourceTask.customColumns = customColumns;
    dispatch(addRtCustomColumns([customColumnToAdd]));
    dispatch(assignResourceTaskSuccess(res.data));
    toast.success(
      <div>
        {t('taskFocus.toastMsg.taskAssignedTo')} <b>{resourceTask.resource.name}</b>
      </div>
    );
    return true;
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(assignResourceTaskError(err.message));
    toast.error("Something went wrong");
    return false;
  }
};

// A refusal comes with a sentence (a frozen task, a read-only project), with an error object, an
// HTML page (a gateway timeout), or nothing at all; only a plain sentence is worth showing as it is.
const isPlainSentence = (body) => {
  if (typeof body !== "string") return false;
  const text = body.trim();
  return text !== "" && !text.startsWith("<") && !/<html|<!doctype/i.test(text);
};

export const taskSaveFailureMessage = (err) => {
  const body = err?.response?.data;
  return isPlainSentence(body) ? body : t("taskFocus.toastMsg.taskSaveFailed");
};

export const updateResourceTask = (data, updateParent = true) => async (
  dispatch
) => {
  //dispatch(updateResourceTaskRequest()); // PLEASE DO NOT ACTIVATE
  try {
    const res = await axios.put(
      `${PDA_PREFIX}/resource-tasks/update-resource-task`,
      data
    );
    if (res.data.parent?.scheduleActivity && updateParent) {
      dispatch(updateRegular(res.data.parent));
    }
    dispatch(updateResourceTaskSuccess(res.data));
    return Promise.resolve(res.data);
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(updateResourceTaskError(err.message));
    toast.error(
      <span data-testid="task-save-failed-toast">{taskSaveFailureMessage(err)}</span>
    );
    return Promise.reject();
  }
};

export const updateUserTask = (data) => async (dispatch) => {
  try {
    await axios.put(`${PDA_PREFIX}/resource-tasks/update-user-task`, data);
    dispatch({
      type: UPDATE_USER_TASK,
      payload: data,
    });
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(updateResourceTaskError(err.message));
  }
};

export const deleteResourceTask = (id, silent = false) => async (dispatch) => {
  if (!silent) dispatch(deleteResourceTaskRequest());
  try {
    const res = await axios.delete(
      `${PDA_PREFIX}/resource-tasks/revoke-resource-task/${id}`
    );
    if (res.data.parent) dispatch(updateRegular(res.data.parent));
    dispatch(deleteResourceTaskSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(deleteResourceTaskError(err.message));
    toast.error("Something went wrong");
  }
};

export const deleteBatchOfResourceTasks = (rtIds, mask) => async (dispatch) => {
  try {
    const formData = new FormData();
    // Append one entry per id so Spring binds Collection<Long> reliably (a raw array becomes a single
    // comma-joined string and fails to parse when deleting large/all selections).
    rtIds.forEach((id) => formData.append("rtIds", id));
    const res = await axios.post(`${PDA_PREFIX}/resource-tasks/delete-all`, formData);
    dispatch({ type: DELETE_BATCH_OF_RESOURCE_TASKS, payload: rtIds });
    if (Array.isArray(res.data) && res.data.length) dispatch({ type: UPDATE_BATCH_OF_REGULARS, payload: res.data });
    mask && mask.close();
    toast.success(<div><b>{rtIds.length} tasks</b> have been removed ! </div>);
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong when trying to delete all the tasks.");
  }
}

export const batchUpdateResourceTasks = (dto) => async (dispatch) => {
  try {
    await axios.patch(`${PDA_PREFIX}/resource-tasks`, dto);
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(deleteResourceTaskError(err.message));
    toast.error("Something went wrong");
  }
};

export const getResourceTaskCustomColumns = () => async (dispatch) => {
  dispatch(getResourceTaskCustomColumnsRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/resource-tasks/custom-column`);
    dispatch(getResourceTaskCustomColumnsSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getResourceTaskCustomColumnsError(err.message));
    toast.error("Something went wrong");
  }
};

export const getResourceTaskCustomColumnsOnPage = (
  pageDatesFilterId = USER_TASKBOARD_DATE_FILTER,
  endpointSuffix = "within-interval"
) => async (dispatch) => {
  dispatch(getResourceTaskCustomColumnsRequest());
  try {
    // todo : make method dynamic, taking start and finish as paramters
    const dates = getDateRange(pageDatesFilterId);
    const formData = new FormData();
    formData.append("start", dates.start);
    formData.append("finish", dates.finish);
    const res = await axios.post(
      `${PDA_PREFIX}/resource-tasks/custom-column/${endpointSuffix}`,
      formData
    );
    dispatch(getResourceTaskCustomColumnsSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getResourceTaskCustomColumnsError(err.message));
    toast.error("Something went wrong");
  }
};

export const renameResourceTaskCustomColumn = (
  columnId,
  newColumnName
) => async (dispatch) => {
  try {
    await axios.put(
      `${PDA_PREFIX}/resource-tasks/custom-column-name/${columnId}`,
      {},
      { params: { newColumnName } }
    );
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error("Something went wrong");
  }
};

export const editResourceTaskCustomColumn = ({
  resourceTaskId,
  columnNameId,
  columnValue,
}) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("columnNameId", columnNameId);
    formData.append("columnValue", columnValue);
    await axios.put(
      `${PDA_PREFIX}/resource-tasks/custom-column/${resourceTaskId}`,
      formData
    );
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error("Something went wrong");
  }
};

export const getResourceTaskCustomColumnNames = () => async (dispatch) => {
  dispatch(getResourceTaskCustomColumnNamesRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/resource-tasks/custom-column-name`
    );
    dispatch(getResourceTaskCustomColumnNamesSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getResourceTaskCustomColumnNamesError(err.message));
    toast.error("Something went wrong");
  }
};

export const updateProgressAndStatus = (taskData) => async (dispatch) => {
  const formData = new FormData();
  const { id, progress, status } = taskData;
  formData.append("id", id);
  formData.append("progress", progress);
  formData.append("status", status);
  try {
    const res = await axios.patch(
      `${PDA_PREFIX}/resource-tasks/progress-and-status`,
      formData
    );
    dispatch({
      type: UPDATE_USER_TASK_STATUS_AND_PROGRESS,
      payload: {
        id,
        progress,
        status,
      },
    });
    if (res?.data?.scheduleActivityId != null && res.data.backlogStatus) {
      dispatch({
        type: SET_BACKLOG_STATUSES,
        payload: [
          {
            scheduleActivityId: res.data.scheduleActivityId,
            backlogStatus: res.data.backlogStatus,
          },
        ],
      });
    }
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    console.error(err);
    toast.error("Something went wrong when moving the task");
  }
};
